/* Change this file to get your personal Portfolio */

// Summary And Greeting Section
import React from 'react';

import emoji from "react-easy-emoji";

const illustration = {
    animated: true // set to false to use static SVG
};

const greeting = {
    username: "linhdoan8",
    title: "Hi all, I'm Linh",
    subTitle: emoji(
        "PhD student in robotics."
    ),
    resumeLink: "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
    displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
    cv: "https://drive.google.com/file/d/1icDPB3-xyI8WS5hLbq2tdhX724dd0wYH/view",
    github: "https://github.com/linhdoan8",
    linkedin: "https://www.linkedin.com/in/linh-kästner/",
    gmail: "linhdoan@win.tu-berlin.de",
    youtube: "https://www.youtube.com/channel/UCp9F4JQvG5Xj2Kc_aSRFTxQ",
    scholar: "https://scholar.google.com/citations?user=Esqp2v8AAAAJ&hl=en",
    researchgate: "https://www.researchgate.net/profile/Linh-Kaestner",
    // Instagram and Twitter are also supported in the links!
    display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
    title: "Skills",
    subTitle: "I love to reimplement papers and develop novel ideas to apply into real robots! ",
    skills: [
        emoji(
            "⚡ Re-implement existing papers/ optimize them"
        ),
        emoji("⚡ Conceptualize and implement novel ideas"),
        emoji(
            "⚡ Integration into real applpications and hardware"
        )
    ],

    /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

    softwareSkills: [{
            skillName: "html-5",
            fontAwesomeClassname: "fab fa-html5"
        },
        {
            skillName: "css3",
            fontAwesomeClassname: "fab fa-css3-alt"
        },
        {
            skillName: "sass",
            fontAwesomeClassname: "fab fa-sass"
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "fab fa-js"
        },
        {
            skillName: "reactjs",
            fontAwesomeClassname: "fab fa-react"
        },
        {
            skillName: "nodejs",
            fontAwesomeClassname: "fab fa-node"
        },
        {
            skillName: "swift",
            fontAwesomeClassname: "fab fa-swift"
        },
        {
            skillName: "npm",
            fontAwesomeClassname: "fab fa-npm"
        },
        {
            skillName: "sql-database",
            fontAwesomeClassname: "fas fa-database"
        },
        {
            skillName: "aws",
            fontAwesomeClassname: "fab fa-aws"
        },
        {
            skillName: "firebase",
            fontAwesomeClassname: "fas fa-fire"
        },
        {
            skillName: "python",
            fontAwesomeClassname: "fab fa-python"
        },
        {
            skillName: "docker",
            fontAwesomeClassname: "fab fa-docker"
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
    display: true, // Set false to hide this section, defaults to true
    schools: [
        
        {
            schoolName: "Technical University Berlin",
            logo: require("./assets/images/logos/tuberlinlogo.png"),
            subHeader: "Dr.-Ing. (Ph.D) (Summa Cum Laude)",
            duration: "Dec 2018 - Dec 2022",
            desc: "Cooperation with Telekom Innovation Labs",
            descBullets: [
                "Reinforcement Learning for Robot Navigation in Crowded Environments",
                "Publication of research papers",
                "Supervision of thesis students",
                "Teaching of 3 courses",
                "Acquisition of industry projects"

            ],
            footerLink: [{
                    name: "",
                    url: ""
                },
                {
                    name: "",
                    url: ""
                }
            ]
        },

        {
            schoolName: "Technical University Berlin",
            logo: require("./assets/images/logos/tuberlinlogo.png"),
            subHeader: "Master of Science in Computer Engineering (GPA: 3.8/4)",
            duration: "October 2018 - October 2020",
            desc: "Cooperation with Federeal Institute for Material Science (BAM)",
            descBullets: [
                "Second master degree carried out in parrallel to the PhD",
                "Intensified research on computer vision methods for quality inspection",
                "Master Thesis: Application of Neural Networks for Thermal Imaging (A)",
                "Published 2 papers in IEEE journals"

            ],
            footerLink: [{
                    name: "Paper 1 (IEEE Transactions on IM) ",
                    url: "https://arxiv.org/pdf/2012.03547.pdf"
                },
                {
                    name: "Paper 2 (IEEE Access)",
                    url: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=9367149"
                }
            ]
        },
        {
            schoolName: "Technical University Berlin",
            logo: require("./assets/images/logos/tuberlinlogo.png"),
            subHeader: "Master of Science in Electrical Engineering (GPA: 3.7/4)",
            duration: "April 2017 - October 2018",
            desc: "Participated in the research of Robotics and published 1 paper.",
            descBullets: [
                "Working Student at Corning, Fraunhofer Institute, and Telekom",
                "Master Thesis: Control of Autonomous Robots Using Augmented Reality (A)"

            ],
            footerLink: [{
                    name: "Demo Video",
                    url: "https://www.youtube.com/watch?v=4to94_LFJj8"
                },
                {
                    name: "Paper",
                    url: "https://ieeexplore.ieee.org/abstract/document/9095836"
                }
            ]
        },
        {
            schoolName: "Technical University Berlin",
            logo: require("./assets/images/logos/tuberlinlogo.png"),
            subHeader: "Bachelor of Science in Electrical Engineering (GPA: 3.3/4)",
            duration: "October 2014 - April 2017",
            desc: "Ranked top 10% in the program. Took courses about Telecommunication Egineering, Microelectronics, Software Engineering",
            // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
            footerLink: [

            ]
        }


    ]
};


const researchinfo = {
    display: true, // Set false to hide this section, defaults to true
    schools: [

        {
            schoolName: "Change-Robust Online Topological Memory for Long-Term Relocalization and Semantic Navigation",
            logo: require("./assets/images/publications/cross-neurips26.png"),
            subHeader: "Jiaming Wang, Jizhuo Chen, Diwen Liu, Atharva Ghotavadekar, Jiaxuan Da, Linh Kästner, and Harold Soh",
            duration: "Dec 2026",
            desc: "NeurIPS 2026, Sydney, Australia",
            footerLink: [{
                    name: "Website",
                    url: "https://jiaming.im/CROSS/"
                },
                {
                    name: "Paper",
                    url: "https://arxiv.org/abs/2605.02227"
                },
                {
                    name: "Code",
                    url: "https://github.com/jiaming-ai/CROSS"
                }
            ]
        },
        {
            schoolName: "PEDS: Closed-Loop Benchmarking of Social Navigation across Pedestrian Behavior Models",
            logo: require("./assets/images/publications/peds-ral26.png"),
            subHeader: "Duc Tai Nguyen, Volodymyr Shcherbyna, Anh Do Duc, Zhengcheng Shen, and Linh Kästner",
            duration: "Oct 2026",
            desc: "IEEE RA-L + ICRA 2027, Seoul, South Korea",
            footerLink: [{
                    name: "Website",
                    url: "https://pedsral26.github.io/"
                },
                {
                    name: "Paper",
                    url: "https://pedsral26.github.io/static/pdfs/PEDS_RAL2026.pdf"
                },
                {
                    name: "Video",
                    url: "https://pedsral26.github.io/#video"
                }
            ]
        },
        {
            schoolName: "GROVE: Grounded Pedestrian Simulation via Natural Language for Interactive Social Robot Navigation",
            logo: require("./assets/images/publications/grove-iros26.png"),
            subHeader: "Duc Tai Nguyen, Volodymyr Shcherbyna, Anh Do Duc, Zhengcheng Shen, Teham Buiyan, and Linh Kästner",
            duration: "Sep 2026",
            desc: "IEEE/RSJ IROS 2026, Pittsburgh, USA",
            footerLink: [{
                name: "Paper",
                url: "https://arxiv.org/abs/2606.25504"
            }]
        },
        {
            schoolName: "D3D-GEN: Robot-Aware Domain-Grounded Interactive 3D World Generation for Social Robotics",
            logo: require("./assets/images/publications/d3d-gen-iros26.png"),
            subHeader: "Anh Duc Do, Volodymyr Shcherbyna, Tai Duc Nguyen, Spaarsh Thakkar, Zhengcheng Shen, Teham Buiyan, Archan Misra, and Linh Kästner",
            duration: "Sep 2026",
            desc: "IEEE/RSJ IROS 2026, Pittsburgh, USA",
            footerLink: [{
                name: "Paper",
                url: "https://arxiv.org/abs/2608.11876"
            }]
        },
        {
            schoolName: "TOPO-Bench: An Open-Source Topological Mapping Evaluation Framework with Quantifiable Perceptual Aliasing",
            logo: require("./assets/images/publications/topo-bench-icra26.png"),
            subHeader: "Jiaming Wang, Jizhuo Chen, Diwen Liu, Jiaxuan Da, Jiamo Hu, Zhiwei Xue, Linh Kästner, and Harold Soh",
            duration: "Jun 2026",
            desc: "IEEE ICRA 2026, Vienna, Austria",
            footerLink: [{
                name: "Paper",
                url: "https://arxiv.org/abs/2510.04100"
            }]
        },
        {
            schoolName: "Arena-Bench 2.0: A Comprehensive Benchmark of Social Navigation Approaches in Collaborative Environments",
            logo: require("./assets/images/publications/intro-new.png"),
            subHeader: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Jiaming Wang, Nhan Trinh, Zhengchen Shen, Giang Nguyen Huu Truong, Tim Lenz, Duc Anh Do, Ahmed Martban, and Eva Wiese",
            duration: "October 2025",
            desc: "IROS 2025, Hangzhou, China ",
            footerLink: [{
                    name: "Preprint",
                    url: "(coming soon, 15 July 2025)"
                },
                {
                    name: "Code",
                    url: "https://github.com/arena-rosnav"
                },
                {
                    name: "Video (coming 20.07.25)",
                    url: ""
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Arena-Rosnav 5.0: A Photorealistic ROS2 Simulation Framework for Developing and Benchmarking Social Navigation",
            logo: require("./assets/images/publications/a5-intro.png"),
            subHeader: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Giang Nguyen Huu Truong, Tim Lenz, Nam Truong Tran, Ahmed Martban, and Harold Soh",
            duration: "April 2025",
            desc: "Proceedings of Robotics Science and Systems (RSS) 2025, Los Angeles, USA",
            footerLink: [{
                    name: "Paper",
                    url: "https://roboticsconference.org/program/papers/92/"
                },
                {
                    name: "Code",
                    url: "https://github.com/arena-rosnav"
                },
                {
                    name: "Video",
                    url: "https://youtu.be/5VdrL1wgMJs"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Arena-Rosnav 4.0: A Comprehensive ROS2 Platform for Human-Centric Navigation and AI-Enhanced Environment Generation",
            logo: require("./assets/images/publications/a4intro.jpg"),
            subHeader: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Giang Nguyen Huu Truong, Maximilian Ho-Kyoung Schreff, Tim Lenz, Nam Truong Tran, Diego Diaz, Ahmed Martban, Jonas Kreutz, and Harold Soh",
            duration: "Sep 2024",
            desc: "IEEE ICRA 2025, Atlanta, USA ",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/abs/2409.12471"
                },
                {
                    name: "Code",
                    url: "https://github.com/arena-rosnav"
                },
                {
                    name: "Video",
                    url: ""
                }
                //  you can add extra buttons here.
            ]
        },

        {
            schoolName: "Arena-Rosnav 3.0: Advancing Social Navigation in Collaborative and Highly Dynamic Environments",
            logo: require("./assets/images/publications/arena3.png"),
            subHeader: "Linh Kästner, Volodymyir Shcherbyna, Huajian Zeng, Tuan Anh Le, Maximilian Ho-Kyoung Schreff, Halid Osmaev, Nam Truong Tran, Diego Diaz, Jan Golebiowski, Harold Soh, Jens Lambrecht",
            duration: "Feb 2024",
            desc: "Proceedings of Robotics Science and Systems (RSS) 2024, Delft, Netherlands",
            footerLink: [{
                    name: "Paper",
                    url: "https://roboticsconference.org/2024/program/papers/74/"
                },
                {
                    name: "Code",
                    url: "https://github.com/arena-rosnav"
                },
                {
                    name: "Video",
                    url: "https://youtu.be/V1ltwfrGoWQ"
                }
                //  you can add extra buttons here.
            ]
        },

        {
            schoolName: "Arena-Rosnav 2.0: A Development and Benchmarking Platform for Robot Navigation in Highly Dynamic Environments",
            logo: require("./assets/images/publications/arena2.png"),
            subHeader: "Linh Kästner, Reyk Carstens, Huajian Zeng, Jacek Kmiecik, Tuan Anh Le, Teham Bhuiyan, Boris Meinardus, Jens Lambrecht",
            duration: "June 2023",
            desc: "IEEE/RSJ IROS 2023, Detroit, USA",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/pdf/2302.10023.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/arena-rosnav"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=OuDSno3V9Ao"
                }
                //  you can add extra buttons here.
            ]
        },

        {
            schoolName: "Arena-Web: A Web-based Development and Benchmarking Platform for Autonomous Navigation Approaches",
            logo: require("./assets/images/publications/arena-web.png"),
            subHeader: "Linh Kästner, Reyk Carstens, Christopher Liebig, Volodymyr Shcherbyna, Lena Nahrworld, Subhin Lee, Jens Lambrecht",
            duration: "March 2023 (Spotlight talk + one out of six demonstrations in the main hall)",
            desc: "Proceedings of Robotics Science and Systems (RSS) 2023, Daegu, Korea",
            footerLink: [{
                    name: "Paper",
                    url: "https://roboticsconference.org/program/papers/088/"
                },
                {
                    name: "Webapp",
                    url: "https://app.arena-rosnav.com"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=C1sLki5bVK8&t=11s"
                }
                //  you can add extra buttons here.
            ]
        },

        {
            schoolName: "Arena-Bench: A Benchmarking Suite for Obstacle Avoidance Approaches on Highly Dynamic Environments",
            logo: require("./assets/images/publications/intro-bench.png"),
            subHeader: "Linh Kästner, Teham Buiyan, Tuan Anh Le, Reyk Carstens, Duc Pichel, Jacek Kmiecik, Elias Treis, Boris Meinardus, Bassel Fatloun, Niloufar Khorsadhi, Jens Lambrecht",
            duration: "October 2022",
            desc: "IEEE Robotics and Automation Letters (RA-L) + IROS 2022, Kyoto, Japan",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/abs/2206.05728"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/arena-bench"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=1YIHD0gBEEE"
                }
                //  you can add extra buttons here.
            ]
        },

        {
            schoolName: "All-in-One: A DRL-based Control Switch Combining State-of-the-art Navigation Planners ",
            logo: require("./assets/images/publications/intro-aio.jpg"),
            subHeader: "Linh Kästner, Johannes Cox, Teham Buiyan, Jens Lambrecht",
            duration: "May 2022",
            desc: "IEEE ICRA 2022, Philadelphia USA",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/pdf/2109.11636.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/all-in-one-DRL-planner"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=h0GPoAcl8rY"
                }
                //  you can add extra buttons here.
            ]
        },
        // {
        //     schoolName: "Obstacle-aware Waypoint Generation for Long-range Guidance of Deep-Reinforcement-Learning-based Navigation Approaches ",
        //     logo: require("./assets/images/intro-ego.jpg"),
        //     subHeader: "Linh Kästner, Xinlin Zhao, Zhengcheng Shen, Jens Lambrecht",
        //     duration: "August 2021",
        //     desc: "",
        //     footerLink: [{
        //             name: "Preprint",
        //             url: "https://arxiv.org/pdf/2109.11639.pdf"
        //         },
        //         {
        //             name: "Code",
        //             url: "https://github.com/ignc-research/arena-fsm-ego-planner"
        //         }
        //         //  you can add extra buttons here.
        //     ]
        // },
        {
            schoolName: "Enhancing Navigational Safety in Crowded Environments using Semantic-Deep-Reinforcement-Learning-based Navigation",
            logo: require("./assets/images/publications/intro-safetydrl.jpg"),
            subHeader: "Linh Kästner, Junhui Li, Bassel Fatloun, Daniel Gawrisch and Jens Lambrecht",
            duration: "May 2022",
            desc: "IEEE ICRA 2022, Philadelphia, USA",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/abs/2109.11288.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/navsafe-arena"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=3IF7_Qe88m8"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Arena-Rosnav: Towards Deployment of Deep-Reinforcement-Learning-Based Obstacle Avoidance into Conventional Autonomous Navigation Systems",
            logo: require("./assets/images/publications/tiipaper.png"),
            subHeader: "Linh Kästner, Teham Buiyan, Xinlin Zhao, Lei Jiao, Zhengcheng Shen, Tuan Anh Le and Jens Lambrecht",
            duration: "June 2021",
            desc: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/pdf/2104.03616.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/arena-rosnav"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=Wt6hFRnOJZY"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Connecting Deep-Reinforcement-Learning-based ObstacleAvoidance with Conventional Global Planners using WaypointGenerators",
            logo: require("./assets/images/publications/intro-new1.jpg"),
            subHeader: "Linh Kästner, Teham Buiyan, Xinlin Zhao, Zhengcheng Shen, Jens Lambrecht",
            duration: "June 2021",
            desc: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/pdf/2104.03663.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/arena-rosnav"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Spatial Imagination With Semantic Cognition for Mobile Robots",
            logo: require("./assets/images/publications/iros21-3.png"),
            subHeader: "Zhengcheng Shen, Linh Kästner, Jens Lambrecht",
            duration: "June 2021 (Nominated for Best Technical Paper Award)",
            desc: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
            footerLink: [{
                    name: "Preprint",
                    url: "https://arxiv.org/pdf/2104.03638.pdf"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/semantic_spatial_imagination"
                },
                {
                    name: "Video (Coming Soon)",
                    url: ""
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "Arena2D - Deep-Reinforcement-Learning-Based Navigation in Highly dynamic Environments",
            logo: require("./assets/images/publications/arena2d.png"),
            subHeader: "Linh Kästner, Cornelius Marx, Jens Lambrecht",
            duration: "August 2020",
            desc: "IEEE/RSJ IROS 2020, Las Vegas, USA, 2020",
            // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
            footerLink: [{
                    name: "Paper",
                    url: "https://ieeexplore.ieee.org/document/9216798"
                },
                {
                    name: "Code",
                    url: "https://github.com/ignc-research/arena2D"
                },
                {
                    name: "Video",
                    url: "https://www.youtube.com/watch?v=Wt6hFRnOJZY"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "A  3D-Deep-Learning-based  Augmented  Reality  Calibration  Method  for Robotic  Environments  using  Depth  Sensor  Data",
            logo: require("./assets/images/publications/icra20paper.png"),
            subHeader: "Linh Kästner, Vlad Frasineanu, Jens Lambrecht",
            duration: "May 2020",
            desc: "IEEE ICRA 2020, 23-28 Mai, Paris, France",
            // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
            footerLink: [{
                    name: "Paper",
                    url: "https://ieeexplore.ieee.org/document/9197155/"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            schoolName: "A Marker-Less AR-Calibration Method for Robotic Environments using RGB-Data",
            logo: require("./assets/images/publications/ur20.png"),
            subHeader: "Linh Kästner, Daniel Dimitrov, Jens Lambrecht",
            duration: "July 2019",
            desc: "IEEE Ubiquitous Robots 2019, 05-08 July, Kyoto, Japan",
            descBullets: ["Created the web application annotate.photo"],
            footerLink: [{
                    name: "Paper",
                    url: "https://ieeexplore.ieee.org/document/9144789"
                },
                {
                    name: "Webapp",
                    url: "http://annotate.photo"
                },
                {
                    name: "Promo Video",
                    url: "https://www.youtube.com/watch?v=Vs83G8x4_6M"
                }
                //  you can add extra buttons here.
            ]
        },

        // {
        //     schoolName: "Memory-Aided Deep Reinforcement Learning for Navigation in Complex Environments",
        //     logo: require("./assets/images/publications/sii20paper.png"),
        //     subHeader: "Linh Kästner, Cornelius Marx, Jens Lambrecht",
        //     duration: "January 2021",
        //     desc: "IEEE SII 2021, Fukushima, Japan",
        //     // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"],
        //     footerLink: [{
        //             name: "Paper (Link coming soon)",
        //             url: "x"
        //         },
        //         {
        //             name: "Code",
        //             url: "https://github.com/ignc-research/arena2D"
        //         }
        //         //  you can add extra buttons here.
        //     ]
        // }


    ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
    viewSkillBars: true, //Set it to true to show Proficiency Section
    experience: [{
            Stack: "Frontend/Design", //Insert stack or technology you have experience in
            progressPercentage: "90%" //Insert relative proficiency in percentage
        },
        {
            Stack: "Backend",
            progressPercentage: "70%"
        },
        {
            Stack: "Programming",
            progressPercentage: "60%"
        }
    ],
    displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
    display: true, //Set it to true to show workExperiences Section
    experience: [
        
        {
            role: "Post-Doctoral Research Fellow",
            company: "National University Singapore",
            companylogo: require("./assets/images/logos/facebookLogo.png"),
            date: "March 2017 – March 2018",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            descBullets: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
            ]
        },
        {
            role: "Working Student",
            company: "Corning Incorporated",
            companylogo: require("./assets/images/logos/facebookLogo.png"),
            date: "March 2017 – March 2018",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            descBullets: [
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
            ]
        },
        {
            role: "Working Student",
            company: "Fraunhofer Gesellschaft",
            companylogo: require("./assets/images/logos/quoraLogo.png"),
            date: "April 2018 – October 2018",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        },
        {
            role: "Master Thesis Researcher",
            company: "Telekom Innovation Labs",
            companylogo: require("./assets/images/logos/airbnbLogo.png"),
            date: "April 2018 – October 2018",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
    ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
    showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
    display: true // Set false to hide this section, defaults to true
};


const achievementSection = {
    title: emoji("Ongoing Projects"),
    subtitle: "I have conducted a number of projects for industrial partners gaining active insights into industrial problems where I applied suitable solutions to solve the problems at hand.",

    

    achievementsCards: [
        {
            image: require("./assets/images/project-images/marl.png"),
            projectName: "Multi Agent Reinforcement Learning",
            projectDesc: "Integration and Development of Multi-Agent-Reinforcement-Learning Approaches for Robots (Homogenous and Heterogenous) for tasks such as rescue or evacutaion",
            //skills: ["Python", "OpenAI Gym", "ROS"],
            footerLink: [{
                name: "View Task Overview",
                url: "https://drive.google.com/file/d/1ID2nI081GGwSu2U48VkIUXuqHq0SJ1Nm/view?usp=sharing"
            },
            {
                name: "View Detailed Project Expose",
                url: "https://drive.google.com/file/d/1ypSdJEfgrcOn6sQl2MszppCyGgxRKNy3/view?usp=sharing"
            }
            //  you can add extra buttons here.
        ]
        },
        {
            title: "BOSCH IC4FF Project",
            image: require("./assets/images/ui/image7.svg"),
            subtitle: "Developed a 3D localization mobile for autonomous ground vehicles to detect and localize 3d assets using only 2D images",
            footerLink: [{
                    name: "Project Website",
                    url: "https://www.ic4f.de/"
                },
                {
                    name: "BOSCH Roadshow Presentation",
                    url: "https://tubcloud.tu-berlin.de/s/zHbCEPcr3W9b3Mr"

                },
                {
                    name: "Whitepaper",
                    url: "https://www.ic4f.de/whitepaper/IC4F-WP-iRefA.pdf"

                }
            ]
        },

        {
            title: "Siemens AG",
            subtitle: "Developed a quality assessment system based on computer vision approaches to assist in quality assurance for high voltage triggers.",
            image: require("./assets/images/ui/image4.svg"),
            footerLink: [{
                name: "NDA Restricted",
                url: "x"
            }]
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
// const achievementSection = {
//     title: emoji("Industrial Experience"),
//     subtitle: "I have conducted a number of projects for industrial partners gaining active insights into industrial problems where I applied suitable solutions to solve the problems at hand.",

    

//     achievementsCards: [{
//             title: "Siemens Power and Gas",
//             subtitle: "Developed a computer vision based failure detection system for wind turbines using Yolo and Faster RCNN and integrated that into the current workstation of Siemens workers. Developed a companion webapplication for improved user understanding.",
//             image: require("./assets/images/project-images/semanticNav.png"),
//             footerLink: [{
//                 name: "View Task Description (PDF)",
//                 url: "http://annotate.photo"
//             },
//             {
//                 name: "View Project Expose",
//                 url: "https://www.youtube.com/watch?v=Vs83G8x4_6M"
//             }
//             //  you can add extra buttons here.
//         ]
//         },
//         {
//             title: "BOSCH IC4FF Project",
//             image: require("./assets/images/image7.svg"),
//             subtitle: "Developed a 3D localization mobile for autonomous ground vehicles to detect and localize 3d assets using only 2D images",
//             footerLink: [{
//                     name: "Project Website",
//                     url: "https://www.ic4f.de/"
//                 },
//                 {
//                     name: "BOSCH Roadshow Presentation",
//                     url: "https://tubcloud.tu-berlin.de/s/zHbCEPcr3W9b3Mr"

//                 },
//                 {
//                     name: "Whitepaper",
//                     url: "https://www.ic4f.de/whitepaper/IC4F-WP-iRefA.pdf"

//                 }
//             ]
//         },

//         {
//             title: "Siemens AG",
//             subtitle: "Developed a quality assessment system based on computer vision approaches to assist in quality assurance for high voltage triggers.",
//             image: require("./assets/images/image4.svg"),
//             footerLink: [{
//                 name: "NDA Restricted",
//                 url: "x"
//             }]
//         }
//     ],
//     display: true // Set false to hide this section, defaults to true
// };

const bigProjects = {
    title: "Ongoing Projects",
    subtitle: "For Undergraduate and Graduate Students at TUB or NUS doing their semester project or thesis. Please contact me via Mail!",
    projects: [{
            image: require("./assets/images/project-images/human-beh.png"),
            projectName: "Robot Behavior Adaptation Based on Semantic Mapping",
            projectDesc: "Navigation and Behavior Adaption for Mobile Robots Based on Semantic Mapping and Social Interactions. Learning-based and/or heuristic approaches should shape the robots behavior.",
            skills: ["Python", "C++", "Gazebo", "ROS"],
            footerLink: [{
                    name: "View Task Overview",
                    url: "https://drive.google.com/file/d/15Kdrgi4sT3JUBL8_SH4YwEjHtpBgKJ0i/view?usp=sharing"
                },
                {
                    name: "View Detailed Project Expose",
                    url: "https://drive.google.com/file/d/1jtrwQTDKTgmZh8XyYxvlntqvG-V0Yq8E/view?usp=sharing"
                }
                //  you can add extra buttons here.
            ]
        },


        {
            image: require("./assets/images/project-images/marl.png"),
            projectName: "Multi Agent Reinforcement Learning",
            projectDesc: "Integration and Development of Multi-Agent-Reinforcement-Learning Approaches for Robots (Homogenous and Heterogenous) for tasks such as rescue or evacutaion",
            skills: ["Python", "OpenAI Gym", "ROS"],
            footerLink: [{
                name: "View Task Overview",
                url: "https://drive.google.com/file/d/1ID2nI081GGwSu2U48VkIUXuqHq0SJ1Nm/view?usp=sharing"
            },
            {
                name: "View Detailed Project Expose",
                url: "https://drive.google.com/file/d/1ypSdJEfgrcOn6sQl2MszppCyGgxRKNy3/view?usp=sharing"
            }
            //  you can add extra buttons here.
        ]
        },
        {
            image: require("./assets/images/project-images/gazebo.png"),
            projectName: "Dynamic World and Scenario Generation Using LLMs",
            projectDesc: "Randomized world and scenario generation is paramount for training and benchmarking. This project try to leverage LLMs to dynamically generate millions of randomized worlds.",
            skills: ["Python", "ML", "LLMs"],
            footerLink: [{
                name: "View Task Description (coming soon)",
                url: ""
            },
            {
                name: "View Project Expose (coming soon)",
                url: ""
            }
            //  you can add extra buttons here.
        ]
        },

        {
            image: require("./assets/images/project-images/quadrupeds.png"),
            projectName: "Quadrupeds in Crowded Outdoor Environments",
            projectDesc: "We recently integrated quadrupeds into our list of available robots inside the ArenaNav platform. The final goal is to deploy a real quadruped robot at the NUS campus and food centers!",
            skills: ["Python", "C++", "Gazebo", "ROS"],
            footerLink: [{
                name: "View Task Description (coming soon)",
                url: ""
            },
            {
                name: "View Detailed Project Expose",
                url: "https://drive.google.com/file/d/1R58gVFJ2kG3yh5E7qH3gclZWlRzVnz6A/view?usp=sharing"
            }
            //  you can add extra buttons here.
        ]
        },
        



    ],
    display: true // Set false to hide this section, defaults to true
};

const ongoingProjects = {
    // title: "Ongoing Projects",
    // subtitle: "For Undergraduate and Graduate Students at TUB or NUS doing their semester project or thesis. Please contact me via Mail!",
    projects:[{
        image: require("./assets/images/project-images/human-beh.png"),
        projectName: "Robot Behavior Adaptation Based on Semantic Mapping",
        projectDesc: "Navigation and Behavior Adaption for Mobile Robots Based on Semantic Mapping and Social Interactions. Learning-based and/or heuristic approaches should shape the robots behavior.",
        skills: ["Python", "C++", "Gazebo", "ROS"],
        footerLink: [{
                name: "View Task Overview",
                url: "https://drive.google.com/file/d/15Kdrgi4sT3JUBL8_SH4YwEjHtpBgKJ0i/view?usp=sharing"
            },
            {
                name: "View Detailed Project Expose",
                url: "https://drive.google.com/file/d/1jtrwQTDKTgmZh8XyYxvlntqvG-V0Yq8E/view?usp=sharing"
            }
        ]
    },

    {
        image: require("./assets/images/project-images/marl.png"),
        projectName: "Multi Agent Reinforcement Learning",
        projectDesc: "Integration and Development of Multi-Agent-Reinforcement-Learning Approaches for Robots (Homogenous and Heterogenous) for tasks such as rescue or evacutaion",
        skills: ["Python", "OpenAI Gym", "ROS"],
        footerLink: [{
            name: "View Task Overview",
            url: "https://drive.google.com/file/d/1ID2nI081GGwSu2U48VkIUXuqHq0SJ1Nm/view?usp=sharing"
        },
        {
            name: "View Detailed Project Expose",
            url: "https://drive.google.com/file/d/1ypSdJEfgrcOn6sQl2MszppCyGgxRKNy3/view?usp=sharing"
        }
        ]
    },
    
    {
        image: require("./assets/images/project-images/gazebo.png"),
        projectName: "Dynamic World and Scenario Generation Using Foundation Models",
        projectDesc: "Randomized world and scenario generation is paramount for training and benchmarking. This project leverages foundation models to dynamically generate millions of randomized worlds.",
        skills: ["Python", "ML", "Foundation Models"],
        footerLink: [{
            name: "Explore the Project",
            url: "mailto:kaestner.linh@gmail.com?subject=Dynamic%20World%20Generation%20Interest"
        },
        {
            name: "View Project Expose (coming soon)",
            url: ""
        }
        ]
    },

    {
        image: require("./assets/images/project-images/quadrupeds.png"),
        projectName: "Quadrupeds in Crowded Outdoor Environments",
        projectDesc: "We recently integrated quadrupeds into our list of available robots inside the ArenaNav platform. The final goal is to deploy a real quadruped robot at the NUS campus and food centers!",
        skills: ["Python", "C++", "Gazebo", "ROS"],
        footerLink: [{
            name: "Explore the Project",
            url: "mailto:kaestner.linh@gmail.com?subject=Quadrupeds%20Project"
        },
        {
            name: "View Detailed Project Expose",
            url: "https://drive.google.com/file/d/1R58gVFJ2kG3yh5E7qH3gclZWlRzVnz6A/view?usp=sharing"
        }
        ]
    },

    {
        image: require("./assets/images/project-images/photoreal.png"),
        projectName: "Photoreal Simulation for Training and Testing",
        projectDesc: "Development and Integration of the ISAAC Gym Simulation into the ArenaNav platform and development of Multimodal training approaches for navigation of robots in crowds.",
        skills: ["Python", "Isaac Gym", "ROS"],
        footerLink: [{
            name: "View Task Overview",
            url: "https://drive.google.com/file/d/1_f_XyFVUBFWYDaMkdNXWuwu9cQHehyKc/view?usp=sharing"
        },
        {
            name: "View Detailed Project Expose",
            url: "https://drive.google.com/file/d/1ZShre4zLgmnAW8JdVotJaTim99Z9b9O7/view?usp=sharing"
        }
        ]
    },
    
    {
        image: require("./assets/images/project-images/semanticNav.png"),
        projectName: "Human Detection and Tracking using RGB-D",
        projectDesc: "Development and integration of computer vision approaches for human detection and tracking as well as action and social state detection. The detected information should be communicated via ROS.",
        skills: ["Python", "Cameras", "CV"],
        footerLink: [{
            name: "View Task Overview",
            url: "https://drive.google.com/file/d/1Ya6fTxlZfQEznasaa97JlJPoThmFPalu/view?usp=sharing"
        },
        {
            name: "Get Involved",
            url: "mailto:kaestner.linh@gmail.com?subject=RGB-D%20Detection%20Project"
        }
        ]
    },
    
    {
        image: require("./assets/images/project-images/arena-web.png"),
        projectName: "Foundation Models for Robotics",
        projectDesc: "Leveraging large-scale foundation models (LLMs, Vision Transformers, Diffusion Models) for robot learning, control, planning, and semantic understanding. Tasks include: prompt-based navigation, vision-language grounding, multi-modal perception, transfer learning from real-world data, and zero-shot generalization to novel tasks and environments.",
        skills: ["Python", "PyTorch", "Foundation Models", "LLMs", "Vision Transformers"],
        footerLink: [{
            name: "Explore Research Direction",
            url: "mailto:kaestner.linh@gmail.com?subject=Foundation%20Models%20for%20Robotics%20Interest"
        },
        {
            name: "View Related Papers",
            url: "https://arxiv.org"
        }
        ]
    }
    ],
    display: true // Set false to hide this section, defaults to true
};


// const bigProjects = {
//     title: "Side-Projects",
//     subtitle: "Published projects and applications",
//     projects: [{
//             image: require("./assets/images/3d-3d.png"),
//             projectName: "annoate.photo",
//             projectDesc: "A web application, which combines all 3 labeling experiences, 2D, 2.5D, and 3D, within one tool inside your browser. No need to install or setup anything, just start labeling your images or 3D point clouds - for free!",
//             footerLink: [{
//                     name: "Visit Website",
//                     url: "http://annotate.photo"
//                 },
//                 {
//                     name: "Promo Video",
//                     url: "https://www.youtube.com/watch?v=Vs83G8x4_6M"
//                 }
//                 //  you can add extra buttons here.
//             ]
//         },
//         {
//             image: require("./assets/images/image6.svg"),
//             projectName: "My personal webpage",
//             projectDesc: "The webpage you are visiting right now, learned some React, Javascript, HTML, and CSS, also some deployment, hosting, and other stuff to get a website online.",
//             footerLink: [{
//                 name: "Visit Website",
//                 url: "http://linhdoan.io"
//             }]
//         },
//         {
//             image: require("./assets/images/image5.svg"),
//             projectName: "CV2",
//             projectDesc: "More info coming soon",
//             footerLink: [{
//                 name: "coming soon",
//                 url: "http://annotate.photo"
//             }]
//         },
//         {
//             image: require("./assets/images/image1.svg"),
//             projectName: "VApp",
//             projectDesc: "more info coming soon",
//             footerLink: [{
//                 name: "coming soon",
//                 url: "http://linhdoan.io"
//             }]
//         },


//     ],
//     display: true // Set false to hide this section, defaults to true
// };

// Achievement Section
// Include certificates, talks etc

// const achievementSection = {
//     title: emoji("Industry Experience"),
//     subtitle: "Industrial projects that I have carried out with industrial partners for major projects financed by the Federal Ministry",

//     achievementsCards: [{
//             title: "Siemens Power and Gas",
//             subtitle: "Developed a live failure detection with computer vision approaches to assist the user to detect stuck airholes inside wind turbine rotors.",
//             image: require("./assets/images/image8.svg"),
//             footerLink: [{
//                     name: "NDA Restricted",
//                     url: "x"
//                 }

//             ]
//         },
//         {
//             title: "BOSCH IC4FF Project",
//             image: require("./assets/images/image7.svg"),
//             subtitle: "Developed a 3D localization mobile for autonomous ground vehicles to detect and localize 3d assets using only 2D images",
//             footerLink: [{
//                     name: "Project Website",
//                     url: "https://www.ic4f.de/"
//                 },
//                 {
//                     name: "BOSCH Roadshow Presentation",
//                     url: "https://tubcloud.tu-berlin.de/s/zHbCEPcr3W9b3Mr"

//                 },
//                 {
//                     name: "Whitepaper",
//                     url: "https://www.ic4f.de/whitepaper/IC4F-WP-iRefA.pdf"

//                 }
//             ]
//         },

//         {
//             title: "Siemens AG",
//             subtitle: "Developed a quality assessment system based on computer vision approaches to assist in quality assurance for high voltage triggers.",
//             image: require("./assets/images/image4.svg"),
//             footerLink: [{
//                 name: "NDA Restricted",
//                 url: "x"
//             }]
//         }
//     ],
//     display: true // Set false to hide this section, defaults to true
// };

// Blogs Section

const blogSection = {
    title: "Blogs",
    subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

    blogs: [{
            url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
            title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
            description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
        },
        {
            url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
            title: "Why REACT is The Best?",
            description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
    title: "TALKS",
    subtitle: emoji(
        "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
    ),

    talks: [{
        title: "Build Actions For Google Assistant",
        subtitle: "Codelab at GDG DevFest Karachi 2019",
        slides_url: "https://bit.ly/saadpasta-slides",
        event_url: "https://www.facebook.com/events/2339906106275053/"
    }],
    display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
    title: emoji("Podcast 🎙️"),
    subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

    // Please Provide with Your Podcast embeded Link
    podcast: [
        "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
    ],
    display: true // Set false to hide this section, defaults to true
};

const studentOpportunities = {
    title: "Opportunities for Students and Researchers",
    subtitle: "Join our lab and work on exciting projects in robotics, AI, and embodied AI!",
    opportunities: [
        {
            level: "Undergraduate and Graduate Students",
            description: 
                "We welcome undergraduate and graduate students to participate in semester projects or 3-12 months paid internships " +
                "and gain hands-on experience with robotics and AI. Work alongside experienced researchers on real-world applications, " +
                "contribute to cutting-edge research, and become an author of publications at top-tier conferences.",
            highlight: "Option to convert to paid internship, RA, or PhD based on results.",
            duration: "3-12 months (flexible)",
            requirements: "Good programming skills, interest in robotics and AI, motivation",
            actionLinks: [{
                name: "Submit CV and Grades",
                url: "mailto:kaestner.linh@gmail.com?subject=Application%20for%20Undergraduate/Graduate%20Student%20Position"
            }]
        },
        {
            level: "PhD Students (Internal)",
            description: 
                "PhD students will conduct original research in embodied AI and robotics, with opportunities to define their own research " +
                "directions. You'll lead projects, mentor junior students, present at conferences, and contribute substantially to the " +
                "advancement of the field. We support a collaborative and intellectually stimulating environment for conducting world-class research.",
            importantNote: "Note: Internal PhD positions are rare with only 2 fully sponsored spots per year or subject to external funding. If you don't secure a spot, please explore our external PhD option.",
            duration: "3-5 years",
            requirements: "Master's degree or equivalent, strong research background and motivation",
            actionLinks: [{
                name: "Submit CV and Grades",
                url: "mailto:kaestner.linh@gmail.com?subject=Application%20for%20Internal%20PhD%20Position"
            },
            {
                name: "Online Application",
                url: "https://computing.smu.edu.sg/phd/online-application"
            }]
        },
        {
            level: "PhD Students (External)",
            description: 
                "Exceptional candidates can also do an external PhD evaluated based on publication count part or full-time!" +
                "and earn their degree with prestigious partner Universities. Your progress and candidacy are " +
                "evaluated based on publication count and research contributions. ",
            importantNote: "Important: A Master's degree is mandatory for this program! Please text me before applying so I can evaluate your profile first.",
            duration: "2-4 years (flexible, part-time or full-time)",
            requirements: "Proven independence, commitment to publications, Master's degree is mandatory!",
            actionLinks: [{
                name: "Submit CV and Grades",
                url: "mailto:kaestner.linh@gmail.com?subject=Application%20for%20External%20PhD%20Position"
            }]
        },
        {
            level: "Postdoctoral Researchers",
            description: 
                "We offer postdoctoral positions for researchers looking to expand their expertise publications, networks to gain faculty or managment positions. " +
                "Postdocs will lead independent research projects, collaborate with international teams, and contribute to grant proposals. " +
                "opportunity to transition to independence and establish yourself as a leading researcher in the field.",
            duration: "1-3 years",
            requirements: "PhD in relevant field, proven research record and publications",
            actionLinks: [{
                name: "Submit CV and Grades",
                url: "mailto:kaestner.linh@gmail.com?subject=Application%20for%20Postdoctoral%20Position"
            }]
        },
        {
            level: "Remote Research Assistant / Freelancers",
            description:
                "Work on exciting robotics, web design, machine learning, and data acquisition projects from anywhere in the world. " +
                "We offer competitive monthly salary with flexible hours. This position offers the option to transition into other programs such as PhD or Master's if interested. " +
                "Contributors can earn co-authorship on research papers and are always welcome to apply for full positions if their work excels.",
            duration: "Flexible (ongoing)",
            requirements: "Strong coding skills (essential), commitment of 10-15 hours per week minimum, interest in robotics or AI",
            actionLinks: [{
                name: "Apply with CV + Portfolio",
                url: "mailto:kaestner.linh@gmail.com?subject=Application%20for%20Remote%20Research%20Assistant&body=Please%20attach%20your%20CV%2C%20portfolio%2C%20and%20describe%20your%20experience%20in%20robotics%2C%20web%20design%2C%20machine%20learning%2C%20or%20data%20acquisition."
            }]
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

const teamSection = {
    title: "Team",
    subtitle: "Meet our research team",
    members: [
        {
            name: "Prof. Dr.-Ing. Linh Kästner",
            position: "Director",
            roleType: "director",
            image: require("./assets/images/portraits/linh-portrait.jpg")
        },
        {
            name: "Dr.-Ing. Volodymyr Shcherbyna",
            position: "Postdoc",
            roleType: "postdoc",
            image: require("./assets/images/portraits/vova-2.png")
        },
        {
            name: "Dr.-Ing. Teham Buiyan",
            position: "Postdoc (incoming)",
            roleType: "postdoc",
            image: require("./assets/images/portraits/teham.jpg")
        },
        {
            name: "Duc Tai Nguyen, B.Sc.",
            position: "PhD Student",
            roleType: "phd",
            image: require("./assets/images/portraits/tai-portrait.jpg")
        },
        {
            name: "Duc Anh Do, B.Sc.",
            position: "PhD Student",
            roleType: "phd",
            image: require("./assets/images/portraits/ducanh-portrait.jpg")
        },
        {
            name: "Huu Giang Nguyen, M.Sc.",
            position: "Research Assistant",
            roleType: "research-assistant",
            image: require("./assets/images/portraits/giang-portrait.jpg")
        },
        {
            name: "Minh Do, M.Sc.",
            position: "External PhD Student (Singapore-MIT Alliance)",
            roleType: "external-phd",
            image: require("./assets/images/portraits/minhdo-portrait.jpg")
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

const externalCollaborators = {
    title: "External Collaborators",
    subtitle: 
        "Our technological inventions such as the Arena platform are year-long efforts spanning a long timeline of over 8 years, across 3 different host universities. " +
        "Thus it involves lots of collaborations with researchers from all over the world. " +
        "If you decide to join us, you may also work closely with the following people who are still actively involved in the projects, " +
        "working on papers and publications, industry projects together, or organizing workshops. A great opportunity to expand your network internationally!",
    members: [
        {
            name: "Jiaming Wang",
            position: "PhD Student, NUS",
            roleType: "collaborator",
            image: require("./assets/images/portraits/jiaming-portrait.jpg")
        },
        {
            name: "Zhengchen Shen",
            position: "Postdoc, Max Planck Germany",
            roleType: "collaborator",
            image: require("./assets/images/portraits/shen-portrait.jpg")
        },
        {
            name: "Huajian Zeng",
            position: "PhD Student, TUM",
            roleType: "collaborator",
            image: require("./assets/images/portraits/huajian-portrait.jpg")
        },
        {
            name: "Ahmed Martban",
            position: "PhD Student, TUB",
            roleType: "collaborator",
            image: require("./assets/images/portraits/ahmed-portrait.jpg")
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

const arenaLabPage = {
    news: [
        {
            title: "ARENA Lab is established, we will be hiring fully-funded students!",
            date: "June 2025",
            tag: "hiring",
            link: "#student-opportunities"
        },
        {
            title: "🎉 1 paper accepted at IROS 2025! Congrats to Vova and team!",
            date: "June 2025",
            tag: "paper"
        },
        {
            title: "🎉 1 paper accepted at RSS 2025!!",
            date: "May 2025",
            tag: "paper"
        },
        {
            title: "🎉 2 papers accepted to ICRA 2025 in Atlanta!",
            date: "Jan 2025",
            tag: "paper"
        },
        {
            title: "🎉 1 paper accepted at RSS 2024!!",
            date: "May 2024",
            tag: "paper"
        },
        {
            title: "👋 Welcome Vova and Teham - new postdocs joining the team!",
            date: "Sep 2024",
            tag: "team"
        },
        {
            title: "🏆 Best Demo Award at RoboSG 2024!",
            date: "Aug 2024",
            tag: "award"
        },
        {
            title: "📄 Arena-Rosnav 3.0 paper accepted at RSS 2024",
            date: "Jun 2024",
            tag: "paper"
        },
        {
            title: "🎓 Nguyen Giang and Duc Anh officially joined as PhD students",
            date: "May 2024",
            tag: "team"
        },
        {
            title: "🎉 Harold receives tenure - celebration time!",
            date: "Apr 2024",
            tag: "award"
        },
        {
            title: "Vova joins team as postdoc (starting Sep 2024)",
            date: "Jan 2024",
            tag: "team"
        },
        {
            title: "🚀 ARENA Lab officially launched at TUB, NUS, SMU!",
            date: "Sep 2020",
            tag: "event"
        }
    ],
    slideshow: [
        {
            image: require("./assets/images/portraits/linh-portrait.jpg"),
            subtitle: "Team collaboration session - discussing new research directions"
        },
        {
            image: require("./assets/images/portraits/tai-portrait.jpg"),
            subtitle: "Robot testing and validation in simulation environment"
        },
        {
            image: require("./assets/images/portraits/ducanh-portrait.jpg"),
            subtitle: "Lab members working on embodied AI projects"
        },
        {
            image: require("./assets/images/portraits/giang-portrait.jpg"),
            subtitle: "Brainstorming session for new research initiatives"
        }
    ],
    teamMembers: [
        {
            name: "Prof. Dr.-Ing. Linh Kästner",
            position: "Director",
            roleType: "director",
            image: require("./assets/images/portraits/linhwithrobots3.png"),
            bio: "Leading ARENA Lab with research focus on embodied AI, robot learning, and autonomous navigation. 10+ years of experience in robotics.",
            previousBackground: "Previous Postdoc at NUS, PhD TUB, Advisor: Harold Soh",
            email: "kaestner.linh@gmail.com",
            researchInterests: ["Embodied AI", "Robot Learning", "Social Navigation", "Simulation"]
        },
        {
            name: "Dr.-Ing. Volodymyr Shcherbyna",
            position: "Postdoc",
            roleType: "postdoc",
            image: require("./assets/images/portraits/vova-2.png"),
            bio: "Expert in robotic manipulation and learning from demonstration. Working on sim2real transfer and robot control.",
            previousBackground: "PhD Student, TU Berlin | Advisor: Linh Kästner",
            email: "volodymyr@smu.edu.sg",
            researchInterests: ["Robotics Simulation", "3D Rendering", "Social Navigation"]
        },
        {
            name: "Dr.-Ing. Teham Buiyan",
            position: "Postdoc (incoming)",
            roleType: "postdoc",
            image: require("./assets/images/portraits/teham.jpg"),
            bio: "Specializing in multi-agent systems and deep reinforcement learning for collaborative robotics.",
            previousBackground: "PhD Student, TU Berlin | Advisor: Linh Kästner",
            email: "teham@smu.edu.sg",
            researchInterests: ["Multi-Agent RL", "Foundation Models", "LLMs for Robotics"]
        },
        {
            name: "Duc Tai Nguyen, B.Sc.",
            position: "PhD Student",
            roleType: "phd",
            image: require("./assets/images/portraits/tai-portrait.jpg"),
            bio: "Researching deep reinforcement learning for robot navigation in crowded environments.",
            previousBackground: "Research Assistant, NUS | Advisor: Linh Kästner | Bachelor: HUST",
            email: "tai.nguyen@smu.edu.sg",
            researchInterests: ["3D Simulation", "Robotics", "Machine Learning"]
        },
        {
            name: "Duc Anh Do, B.Sc.",
            position: "PhD Student",
            roleType: "phd",
            image: require("./assets/images/portraits/ducanh-portrait.jpg"),
            bio: "Working on perception and semantic understanding for embodied AI systems.",
            previousBackground: "Research Assistant, NUS | Advisor: Linh Kästner | Bachelor: FPT University Hanoi",
            email: "anh.do@smu.edu.sg",
            researchInterests: ["3D Simulation", "Robotics", "Machine Learning"]
        },
        {
            name: "Huu Giang Nguyen, M.Sc.",
            position: "Research Assistant",
            roleType: "research-assistant",
            image: require("./assets/images/portraits/giang-portrait.jpg"),
            bio: "Supporting research projects in robot simulation and benchmarking platforms.",
            previousBackground: "Research Assistant, NUS | Advisor: Linh Kästner | Bachelor: HUST",
            email: "giang@smu.edu.sg",
            researchInterests: ["Social Force Modeling", "Robotics Simulation"]
        },
        {
            name: "Minh Do, M.Sc.",
            position: "External PhD Student (Singapore-MIT Alliance)",
            roleType: "external-phd",
            image: require("./assets/images/portraits/minhdo-portrait.jpg"),
            bio: "Collaborative PhD student working on human-robot interaction and social navigation. MIT Research Engineer with advisors: Daniela Rus (MIT), Archan Misra (SMU), Jinhua Zhao (MIT).",
            previousBackground: "B.Eng. HUST | M.Sc. NTU, Advisor: Archan Misra",
            email: "minh.do@smu.edu.sg",
            researchInterests: ["Human-Robot Interaction", "Social Navigation", "VLMs and VLAs"]
        },
        {
            name: "Jiaming Wang",
            position: "External PhD Student, NUS",
            roleType: "collaborator",
            image: require("./assets/images/portraits/jiaming-portrait.jpg"),
            bio: "External collaborator specializing in navigation, mapping, control, and vision-language-action models.",
            previousBackground: "Startup Founder (acquired) | Forbes 30 under 30 | B.Sc. and M.Sc. NUS, Advisor: Harold Soh",
            email: "jiaming@nus.edu.sg",
            researchInterests: ["Navigation", "Mapping", "Control", "VLA"]
        }
    ],
    publications: [
        {
            title: "Arena-Bench 2.0: A Comprehensive Benchmark of Social Navigation Approaches in Collaborative Environments",
            authors: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Jiaming Wang, Nhan Trinh, Zhengchen Shen, Giang Nguyen Huu Truong, Tim Lenz, Duc Anh Do, Ahmed Martban, and Eva Wiese",
            venue: "IROS 2025, Hangzhou, China",
            date: "October 2025",
            image: require("./assets/images/publications/intro-new.png"),
            tags: ["Benchmarking", "Social Navigation", "Collaboration"],
            footerLink: [
                { name: "Paper", url: "https://arxiv.org/abs/2501.19999" },
                { name: "Code", url: "https://github.com/arena-rosnav" },
                { name: "Video", url: "https://www.youtube.com/watch?v=arena-bench-2" }
            ]
        },
        {
            title: "Arena-Rosnav 5.0: A Photorealistic ROS2 Simulation Framework for Developing and Benchmarking Social Navigation",
            authors: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Giang Nguyen Huu Truong, Tim Lenz, Nam Truong Tran, Ahmed Martban, and Harold Soh",
            venue: "Proceedings of Robotics Science and Systems (RSS) 2025, Los Angeles, USA",
            date: "April 2025",
            image: require("./assets/images/publications/a5-intro.png"),
            tags: ["Photorealistic", "ROS2", "Simulation"],
            footerLink: [
                { name: "Paper", url: "https://roboticsconference.org/program/papers/92/" },
                { name: "Code", url: "https://github.com/arena-rosnav" },
                { name: "Video", url: "https://www.youtube.com/watch?v=rss2025-arena" }
            ]
        },
        {
            title: "Arena-Rosnav 4.0: A Comprehensive ROS2 Platform for Human-Centric Navigation and AI-Enhanced Environment Generation",
            authors: "Volodymyir Shcherbyna, Linh Kästner, Huajian Zeng, Giang Nguyen Huu Truong, Maximilian Ho-Kyoung Schreff, Tim Lenz, Nam Truong Tran, Diego Diaz, Ahmed Martban, Jonas Kreutz, and Harold Soh",
            venue: "IEEE ICRA 2025, Atlanta, USA",
            date: "September 2024",
            image: require("./assets/images/publications/a4intro.jpg"),
            tags: ["Human-Centric", "ROS2", "AI Generation"],
            footerLink: [
                { name: "Paper", url: "https://arxiv.org/abs/2409.12471" },
                { name: "Code", url: "https://github.com/arena-rosnav" },
                { name: "Project Page", url: "https://arena-rosnav.readthedocs.io" }
            ]
        },
        {
            title: "Arena-Rosnav 3.0: Advancing Social Navigation in Collaborative and Highly Dynamic Environments",
            authors: "Linh Kästner, Volodymyir Shcherbyna, Huajian Zeng, Tuan Anh Le, Maximilian Ho-Kyoung Schreff, Halid Osmaev, Nam Truong Tran, Diego Diaz, Jan Golebiowski, Harold Soh, Jens Lambrecht",
            venue: "Proceedings of Robotics Science and Systems (RSS) 2024, Delft, Netherlands",
            date: "February 2024",
            image: require("./assets/images/publications/arena3.png"),
            tags: ["Social Navigation", "Collaboration", "Dynamics"],
            footerLink: [
                { name: "Paper", url: "https://roboticsconference.org/2024/program/papers/74/" },
                { name: "Code", url: "https://github.com/arena-rosnav" },
                { name: "Video", url: "https://www.youtube.com/watch?v=rss2024-arena" }
            ]
        },
        {
            title: "Arena-Rosnav 2.0: A Development and Benchmarking Platform for Robot Navigation in Highly Dynamic Environments",
            authors: "Linh Kästner, Reyk Carstens, Huajian Zeng, Jacek Kmiecik, Tuan Anh Le, Teham Bhuiyan, Boris Meinardus, Jens Lambrecht",
            venue: "IEEE/RSJ IROS 2023, Detroit, USA",
            date: "June 2023",
            image: require("./assets/images/publications/arena2.png"),
            tags: ["Platform", "Benchmarking", "Dynamic Environments"],
            footerLink: [
                { name: "Paper", url: "https://arxiv.org/pdf/2302.10023.pdf" },
                { name: "Code", url: "https://github.com/arena-rosnav" },
                { name: "Video", url: "https://www.youtube.com/watch?v=OuDSno3V9Ao" }
            ]
        },
        {
            title: "Arena-Web: A Web-based Development and Benchmarking Platform for Autonomous Navigation Approaches",
            authors: "Linh Kästner, Reyk Carstens, Christopher Liebig, Volodymyr Shcherbyna, Lena Nahrworld, Subhin Lee, Jens Lambrecht",
            venue: "Proceedings of Robotics Science and Systems (RSS) 2023, Daegu, Korea",
            date: "March 2023",
            image: require("./assets/images/publications/arena-web.png"),
            tags: ["Web Platform", "Development", "Benchmarking"],
            footerLink: [
                { name: "Paper", url: "https://roboticsconference.org/program/papers/088/" },
                { name: "Code", url: "https://github.com/arena-rosnav/arena-web" },
                { name: "Project Page", url: "https://arena-web.readthedocs.io" }
            ]
        },
        {
            title: "Arena-Bench: A Benchmarking Suite for Obstacle Avoidance Approaches on Highly Dynamic Environments",
            authors: "Linh Kästner, Teham Buiyan, Tuan Anh Le, Reyk Carstens, Duc Pichel, Jacek Kmiecik, Elias Treis, Boris Meinardus, Bassel Fatloun, Niloufar Khorsadhi, Jens Lambrecht",
            venue: "IEEE Robotics and Automation Letters (RA-L) + IROS 2022, Kyoto, Japan",
            date: "October 2022",
            image: require("./assets/images/publications/intro-bench.png"),
            tags: ["Benchmarking", "Obstacle Avoidance", "Dynamic"],
            footerLink: [
                { name: "Paper", url: "https://arxiv.org/abs/2206.05728" },
                { name: "Code", url: "https://github.com/ignc-research/arena-bench" },
                { name: "Video", url: "https://www.youtube.com/watch?v=1YIHD0gBEEE" }
            ]
        },
        {
            title: "All-in-One: A DRL-based Control Switch Combining State-of-the-art Navigation Planners",
            authors: "Linh Kästner, Johannes Cox, Teham Buiyan, Jens Lambrecht",
            venue: "IEEE ICRA 2022, Philadelphia USA",
            date: "May 2022",
            image: require("./assets/images/publications/intro-aio.jpg"),
            tags: ["Deep RL", "Navigation", "Control"],
            footerLink: [
                { name: "Paper", url: "https://arxiv.org/pdf/2109.11636.pdf" },
                { name: "Code", url: "https://github.com/ignc-research/all-in-one" }
            ]
        },
        {
            title: "Enhancing Navigational Safety in Crowded Environments using Semantic-Deep-Reinforcement-Learning-based Navigation",
            authors: "Linh Kästner, Junhui Li, Bassel Fatloun, Daniel Gawrisch and Jens Lambrecht",
            venue: "IEEE ICRA 2022, Philadelphia, USA",
            date: "May 2022",
            link: "https://arxiv.org/abs/2109.11288.pdf",
            tags: ["Safety", "Crowds", "Semantic DRL"]
        },
        {
            title: "Arena-Rosnav: Towards Deployment of Deep-Reinforcement-Learning-Based Obstacle Avoidance into Conventional Autonomous Navigation Systems",
            authors: "Linh Kästner, Teham Buiyan, Xinlin Zhao, Lei Jiao, Zhengcheng Shen, Tuan Anh Le and Jens Lambrecht",
            venue: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            date: "June 2021",
            link: "https://arxiv.org/pdf/2104.03616.pdf",
            tags: ["Deep RL", "Deployment", "Navigation"]
        },
        {
            title: "Connecting Deep-Reinforcement-Learning-based Obstacle Avoidance with Conventional Global Planners using Waypoint Generators",
            authors: "Linh Kästner, Teham Buiyan, Xinlin Zhao, Zhengcheng Shen, Jens Lambrecht",
            venue: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            date: "June 2021",
            link: "https://arxiv.org/pdf/2104.03663.pdf",
            tags: ["Waypoint", "Deep RL", "Planning"]
        },
        {
            title: "Spatial Imagination With Semantic Cognition for Mobile Robots",
            authors: "Zhengcheng Shen, Linh Kästner, Jens Lambrecht",
            venue: "IEEE/RSJ IROS, Prague, Czech Republic, 2021",
            date: "June 2021",
            link: "https://arxiv.org/pdf/2104.03638.pdf",
            tags: ["Semantic", "Cognition", "Spatial AI"]
        },
        {
            title: "Arena2D - Deep-Reinforcement-Learning-Based Navigation in Highly dynamic Environments",
            authors: "Linh Kästner, Cornelius Marx, Jens Lambrecht",
            venue: "IEEE/RSJ IROS 2020, Las Vegas, USA",
            date: "August 2020",
            link: "https://ieeexplore.ieee.org/document/9216798",
            tags: ["2D Simulation", "Deep RL", "Navigation"]
        },
        {
            title: "A 3D-Deep-Learning-based Augmented Reality Calibration Method for Robotic Environments using Depth Sensor Data",
            authors: "Linh Kästner, Vlad Frasineanu, Jens Lambrecht",
            venue: "IEEE ICRA 2020, Paris, France",
            date: "May 2020",
            link: "https://ieeexplore.ieee.org/document/9197155/",
            tags: ["AR", "Deep Learning", "Calibration"]
        },
        {
            title: "A Marker-Less AR-Calibration Method for Robotic Environments using RGB-Data",
            authors: "Linh Kästner, Daniel Dimitrov, Jens Lambrecht",
            venue: "IEEE Ubiquitous Robots 2019, Kyoto, Japan",
            date: "July 2019",
            link: "https://ieeexplore.ieee.org/document/9144789",
            tags: ["AR", "Markerless", "RGB"]
        }
    ],
    opportunities: [
        {
            position: "PhD Students (Internal)",
            type: "Fully funded",
            description: "Conduct original research in embodied AI and robotics, lead publications, and help mentor junior students within ARENA Lab.",
            duration: "3-5 years",
            deadline: "31.01. and 31.08. each year",
            requirements: [
                "Bachelor's or Master's degree (required)",
                "Strong research background in robotics / AI",
                "Motivation to publish and drive projects"
            ],
            applyLinks: [
                {
                    label: "Send CV + transcript",
                    url: "mailto:kaestner.linh@gmail.com?subject=Internal%20PhD%20Application&body=Please%20attach%20your%20CV%20and%20transcript."
                },
                {
                    label: "Admissions webpage",
                    url: "https://computing.smu.edu.sg/phd/online-application"
                }
            ]
        },
        {
            position: "PhD Students (External)",
            type: "External / part-time",
            description: "Earn an external PhD (part-time or full-time) with progress evaluated through publications and research contributions.",
            duration: "2-4 years (flexible)",
            deadline: "Rolling admissions",
            requirements: [
                "Master's degree is mandatory",
                "Proven independence and publication record",
                "Commitment to sustained research output"
            ],
            applyLinks: [
                {
                    label: "Send CV + transcript",
                    url: "mailto:kaestner.linh@gmail.com?subject=External%20PhD%20Application&body=Please%20attach%20your%20CV%20and%20transcript."
                }
            ]
        },
        {
            position: "Postdoctoral Researcher",
            type: "1-3 years",
            description: "Lead independent research, collaborate internationally, and help shape the lab's embodied AI and robotics agenda.",
            duration: "1-3 years",
            deadline: "Rolling admissions",
            requirements: [
                "PhD in robotics, AI, or related field",
                "Strong publication track record",
                "Collaborative mindset and initiative"
            ],
            applyLinks: [
                {
                    label: "Send CV + transcript",
                    url: "mailto:kaestner.linh@gmail.com?subject=Postdoc%20Application&body=Please%20attach%20your%20CV%20and%20transcript."
                }
            ]
        },
        {
            position: "Undergrad / Grad Students",
            type: "3-12 months",
            description: "Join for semester projects or internships, gain hands-on experience, and contribute to publications with the team.",
            duration: "3-12 months",
            deadline: "Rolling admissions",
            requirements: [
                "Interest in robotics and AI",
                "Good programming skills",
                "Ability to commit 10-20 hours/week"
            ],
            applyLinks: [
                {
                    label: "Send CV + transcript",
                    url: "mailto:kaestner.linh@gmail.com?subject=Undergrad%2FGrad%20Application&body=Please%20attach%20your%20CV%20and%20transcript."
                }
            ]
        },
        {
            position: "Remote Research Assistant / Freelancers",
            type: "Flexible remote work",
            description: "Work on robotics, web design, machine learning, and data acquisition modules from anywhere. Competitive monthly salary with flexible hours and opportunities to grow within our research group.",
            duration: "Flexible (ongoing)",
            deadline: "Rolling admissions (always open)",
            requirements: [
                "Strong coding skills (required)",
                "Commitment of 10-15 hours per week minimum",
                "Interest in robotics, AI, or related fields"
            ],
            applyLinks: [
                {
                    label: "Send CV + portfolio",
                    url: "mailto:kaestner.linh@gmail.com?subject=Remote%20Research%20Assistant%20Application&body=Please%20attach%20your%20CV%20and%20portfolio.%20Mention%20your%20skills%20in%20robotics%2C%20web%20design%2C%20ML%2C%20or%20data%20acquisition."
                },
                {
                    label: "Learn about benefits",
                    url: "mailto:kaestner.linh@gmail.com?subject=Remote%20Research%20Assistant%20-%20Benefits%20and%20Salary%20Info&body=Hi%20Linh%2C%20Could%20you%20tell%20me%20more%20about%20the%20salary%20and%20benefits%20for%20the%20remote%20research%20assistant%20position%3F"
                }
            ]
        }
    ]
};

const contactInfo = {
    title: emoji("Contact Me ☎️"),
    subtitle: (<span>
    <span style={{color: '#e74c3c', fontWeight: 'bold'}}>I am actively hiring graduate, undergraduate and fully funded PhD students!</span> {' '}
    Please have a look at the{' '}
    <a href="#student-opportunities" style={{ color: '#6495ED' }}>opportunities to join section</a> to learn more. {' '}
    For exciting projects about embodied AI, robotics, foundation models for robotics. Please take a look at the{' '}
    <a href="#projects" style={{ color: '#6495ED' }}>ongoing projects section</a> to learn more about the projects and <a href="mailto:kaestner.linh@gmail.com" style={{ color: '#6495ED' }}>
        send me an email
      </a> if interested!
  </span>),
    number: "+49-172",
    email_address: "linhdoan@win-tu-berlin.de",
    subTitle: 
        (<span>
            I am an Assistant Professor at Singapore Managment University (SMU) building the newly established Embodied AI cluster at the school and directing the <a href="https://arena-lab.org" target="_blank" rel="noopener noreferrer" style={{ color: '#6495ED', textDecoration: 'none' }}>ARENA-Lab</a>. {' '}
            <span style={{fontWeight: "bold", fontSize: "1.05em", backgroundColor: "rgba(100, 149, 237, 0.15)", padding: "2px 6px", borderRadius: "4px"}}>
                Despite its name, SMU is currently heavily investing in Embodied AI and now ranks #2 globally in software engineering according to CSRankings!
            </span>{' '}
            Prior to that, I was a postdoctoral scientist at <a href="https://clear-nus.github.io/" style={{ color: '#6495ED' }}>Clear Lab</a>, National University of Singapore (NUS) under Prof. <a href="https://haroldsoh.com/" style={{ color: '#6495ED' }}>Harold Soh</a>. I received my Ph.D (Dr.-Ing.) in Robotics and Reinforcement Learning from Technical University Berlin (TUB) in 2023. {' '}
            My master degrees in Electrical Engineering and Computer Engineering specializing in robotics and telecommunication were attained in 2018 and 2020, {' '}
            respectively at the Technical University of Berlin, Germany. {' '}
            
        </span>),
    description: "Welcome to my page! I received my Master's degree in Electrical Engineering, specializing in telecommunication and robotics, from the Technical University of Berlin, Germany in 2018. Currently I am pursuing my PhD in artificial intelligence and robotics with focus on autonomous navigation and machine perception @ Technical University Berlin and Telekom Innovation Labs  "
};

// Twitter Section

const twitterDetails = {
    userName: "twitter", //Replace "twitter" with your twitter username without @
    display: true // Set true to display this section, defaults to false
};

export {
    illustration,
    greeting,
    socialMediaLinks,
    skillsSection,
    educationInfo,
    researchinfo,
    techStack,
    workExperiences,
    openSource,
    bigProjects,
    ongoingProjects,
    achievementSection,
    blogSection,
    talkSection,
    podcastSection,
    studentOpportunities,
    teamSection,
    externalCollaborators,
    arenaLabPage,
    contactInfo,
    twitterDetails
};